import React from 'react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Menu } from './components/Menu';
import { Location } from './components/Location';
import { Footer } from './components/Footer';
export function App() {
  return <main className="relative min-h-screen bg-[#FFF8E7]" data-id="element-0">
      {/* Texture Overlays */}
      <div className="fixed inset-0 bg-checkered pointer-events-none z-0" data-id="element-1" />
      <div className="texture-overlay" data-id="element-2" />

      {/* Content */}
      <div className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Menu data-id="element-6" />
        <Location data-id="element-7" />
        <Footer data-id="element-8" />
      </div>
    </main>;
}